import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { EditorNames } from '../EditorNames';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { NumericEditorType } from '@decisions/server/DecisionsFramework/Design/Properties/NumericEditorType';
import { NumericArrayEditorType } from '@decisions/server/DecisionsFramework/Design/Properties/Attributes/NumericArrayEditorType';

export function isNumericEditor(editor: IPropertyChild) {
  return editor.Node.MvcEditorName === EditorNames.Digits;
}

export function getFieldType(editor: IPropertyChild) {
  // number field is a bit too harsh, it turns out...
  return /* isNumericEditor(editor) ? 'number' : */ 'text'; // TODO others
}

export function isNullableType(editor: IPropertyChild) {
  return getEditorConfigValue(editor, 'NullableType');
}

export function getNumericEditorType(editor: IPropertyChild): NumericEditorType {
  return getEditorConfigValue(editor, 'NumericType');
}

export function isFloatEditor(editor: IPropertyChild) {
  switch (getNumericEditorType(editor)) {
    case NumericEditorType.Double:
    case NumericEditorType.Single:
    case NumericEditorType.Decimal:
      return true;
    default:
      return false;
  }
}

export function getNumericArrayEditorType(editor: IPropertyChild): NumericArrayEditorType {
  return getEditorConfigValue(editor, 'NumericType');
}

export function isArrayFloatEditor(editor: IPropertyChild) {
  switch (getNumericArrayEditorType(editor)) {
    case NumericArrayEditorType.DoubleArray:
    case NumericArrayEditorType.DecimalArray:
      return true;
    default:
      return false;
  }
}

// since these sizes are known, we could totally validate against them,
// unless that's too much work on the client.
// https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/builtin-types/integral-numeric-types
